import {BaseView} from "../core/view"
import { LinkUtil } from "../utils/link"
import Clusterize from "clusterize.js"
import { SelectorUtil } from "../utils/selector-util"

export default BaseView.extend({

    activeElementLink: undefined,
    initialActiveFilters: undefined,
    filterType: undefined,
    filterData: undefined,
    searchterm: undefined,
    clusterize: undefined,
    firstLoad: undefined,
    multiSelect: false,
    premiumHeadline : '<li class="list-group-item"><span class="list-group-item__title">' + getI18N(jlocale.premiumShops) + '</span></li>',
    regularHeadline : '<li class="list-group-item"><span class="list-group-item__title">' + getI18N(jlocale.allShops) + '</span></li>',

    
    templates: {
        LIST_FILTER_TEMPLATE: require("./templates/mobile-filter-list-template.hbs"),
        COLOR_FILTER_TEMPLATE: require("./templates/mobile-color-filter-template.hbs")
    },


    events: {
        'keyup .js-filter-input': 'handleKeyboardInput',
        'click .js-filter-input': 'stopPropagation',
        'submit .js-filter-form': 'handleSubmit',
        'focus .js-filter-input': 'onSearchFocus',
        'blur .js-filter-input': 'onSearchBlur',
        'click .js-select-filter' : 'onFilterClick',
        'click .js-filter-input-reset' : 'onResetSearch'
    },

    stopPropagation: function(e) {
        e.stopPropagation();
    },

    swingScroll: function(){
        const currentPosition = window.pageYOffset;
        if(currentPosition === 0){
            window.scroll(0, 1);
            window.scroll(0, 0);
        }
        else{
            window.scroll(0, currentPosition - 1);
            window.scroll(0, currentPosition);
        }
    },
    
    onActiveFilterClick: function(data){
        this.manageFilterItem(data);
    },
    
    onSearchFocus: function(e){
        this.$el.find(e.currentTarget).parent().addClass('list-search--active');
        this.swingScroll();

        const filterType = SelectorUtil.closest(e.currentTarget, '.js-filter-button');
        const filterBody = document.querySelector('.js-filter-body');
        filterBody.scroll(0, (filterType.getBoundingClientRect().top - filterBody.getBoundingClientRect().top) + filterBody.scrollTop);
    },
    
    onSearchBlur: function(e){
        this.$el.find(e.currentTarget).parent().removeClass('list-search--active');
    },
    
    onResetSearch: function(e){
        this.$el.find('.js-filter-input').val('');
        this.searchterm = "";
        this.manageFillList();
    },
    
    onFilterClick: function(e) {
        e.preventDefault();
        var data = {
            filterType : this.filterType,
            filterValue : this.$el.find(e.currentTarget).data("filter-value"),
            filterName : String(this.$el.find(e.currentTarget).data("filter-name")).trim()
        };
        this.manageFilterItem(data);
        Backbone.trigger('applyMobileListFilter',data);
    },
       
    manageFilterItem: function(item){
        var self = this;
        self.filterData = _.map(self.filterData,function(itm){
            if (itm.id == item.filterValue){
                itm.active = itm.active == true ? false : true;
            }else if ((self.multiSelect == false)&&(itm.active==true)){
                itm.active = false;
                var data = {
                    filterType : self.filterType,
                    filterValue : itm.id,
                    filterName : itm.name.trim()
                };
                Backbone.trigger('applyMobileListFilter',data);
            }
            return itm;
        });
        self.manageFillList();
    },
    
    clearFilter: function(){
        this.filterData = _.map(this.filterData,function(itm){
            itm.active = false;
            return itm;
        });
        this.manageFillList();
    },
    
    handleSubmit: function(e) {
        e.stopPropagation();
        e.preventDefault();

        if(this.activeElementLink === undefined){
            this.activeElementLink = this.$el.find('li:first a').attr('href');
        }
        LinkUtil.goToUrl(this.activeElementLink);
    },

    handleKeyboardInput: _.debounce(function(e) {

        var inputElement = this.$el.find(e.currentTarget),
            searchterm = $(inputElement).val();
            
        this.searchterm = searchterm.toLowerCase();
        this.manageFillList();
        
    },500),
    
    manageFillList: function(){
        if (this.filterType=="shop"){
            this.fillListShop();
        }else if (this.filterType=="color"){
            this.fillListColor();
        }else {
            this.fillList();
        }
    },
 
    fillList: function(){
        var self = this;
        var activeList = self.filterData;
        
        if (self.searchterm){
            activeList = _.filter(activeList, function(itm){
                return itm.name.toLowerCase().indexOf(self.searchterm) >= 0;
            });
        }
        
        if (activeList.length>500){
            var code = [];
            $.each(activeList, function(i, val) {
                var htmlname = val.name;
                if (self.searchterm!=''){
                    htmlname = val.name.replace(new RegExp('(' + self.searchterm + ')', 'gi'), "<strong>$1</strong>");
                }

                var data = {
                    name: val.name,
                    htmlname: htmlname,
                    url: val.url,
                    active: val.active,
                    colorId: val.colorId,
                    filterType : this.filterType,
                    id : val.id
                }
                
                code.push(self.templates.LIST_FILTER_TEMPLATE(data));

            });

            if (self.clusterize==undefined){
                self.clusterize = new Clusterize({
                    rows: code,
                    tag: 'li',
                    scrollElem: this.$el.get(0),
                    contentElem:  this.$el.find('.js-filter-list').get(0),
                });
            }else{
                self.clusterize.update(code);
            }
            
            
            
        }else{
            self.clusterize=undefined;
            var code = '';
            $.each(activeList, function(i, val) {
                var htmlname = val.name;
                if (self.searchterm!=''){
                    htmlname = val.name.replace(new RegExp('(' + self.searchterm + ')', 'gi'), "<strong>$1</strong>");
                }

                var data = {
                    name: val.name,
                    htmlname: htmlname,
                    url: val.url,
                    active: val.active,
                    colorId: val.colorId,
                    filterType : this.filterType,
                    id : val.id
                }
                
                code += self.templates.LIST_FILTER_TEMPLATE(data);

            });
            
            this.$el.find(".js-filter-list").html(code);
        }
        
        if (this.firstLoad){
            $.each(_.filter(activeList,function(itm){return itm.active == true}),function(i,val){
                var data = {
                    filterType : self.filterType,
                    filterValue : val.id,
                    filterName : val.name
                };
                Backbone.trigger('applyMobileListFilter',data);
            });
        }
        
        this.firstLoad = false;
        
    },
    
    fillListShop: function(){
        //filter shops
        var self = this;
        var code = '';
        var activeList = self.filterData;
        
        if (self.searchterm){
            activeList = _.filter(activeList, function(itm){
                return itm.name.toLowerCase().indexOf(self.searchterm) >= 0;
            });
        }
        
        var data = _.groupBy(activeList, function(itm){ return itm.premium == true; });
        
        if (data.true){
            code+= this.premiumHeadline;
            $.each(data.true, function(i, val) {
                var htmlname = val.name;
                if (self.searchterm!=''){
                    htmlname = val.name.replace(new RegExp('(' + self.searchterm + ')', 'gi'), "<strong>$1</strong>");
                }

                var data = {
                    name: val.name,
                    htmlname: htmlname,
                    url: val.url,
                    active: val.active,
                    colorId: val.colorId,
                    filterType : this.filterType,
                    id : val.id
                }
                
                code += self.templates.LIST_FILTER_TEMPLATE(data);

            });
            code+= this.regularHeadline;
        }
        
        if (data.false){
            
            $.each(data.false, function(i, val) {
                var htmlname = val.name;
                if (self.searchterm!=''){
                    htmlname = val.name.replace(new RegExp('(' + self.searchterm + ')', 'gi'), "<strong>$1</strong>");
                }

                var data = {
                    name: val.name,
                    htmlname: htmlname,
                    url: val.url,
                    active: val.active,
                    colorId: val.colorId,
                    filterType : this.filterType,
                    id : val.id
                }
                
                code += self.templates.LIST_FILTER_TEMPLATE(data);

            });
            
        }
        
        if (this.firstLoad){
            $.each(_.filter(activeList,function(itm){return itm.active == true}),function(i,val){
                var data = {
                    filterType : self.filterType,
                    filterValue : val.id,
                    filterName : val.name
                };
                Backbone.trigger('applyMobileListFilter',data);
            });
        }
        
        this.firstLoad = false;
        
        
        this.$el.find(".js-filter-list").html(code);
    },
    
    fillListColor: function(){
        var self = this;
                
        
        var code = '';
        $.each(this.filterData, function(i, val) {
            var name = val.name;

            var data = {
                searchname: val.name.toLowerCase(),
                name: name,
                url: val.url,
                active: val.active,
                colorId: val.colorId,
                filterType : this.filterType,
                id : val.id
            }
            
            code += self.templates.COLOR_FILTER_TEMPLATE(data);

        });
        
        if (this.firstLoad){
            $.each(_.filter(this.filterData,function(itm){return itm.active == true}),function(i,val){
                var data = {
                    filterType : self.filterType,
                    filterValue : val.id,
                    filterName : val.name
                };
                Backbone.trigger('applyMobileListFilter',data);
            });
        }
        
        this.firstLoad = false;
        
        this.$el.find(".js-filter-list").html(code);
        
    },
    
    setActiveFilters: function(){
        var self = this;
        self.filterData = _.map(self.filterData,function(itm){
            if (_.filter(self.initialActiveFilters, { filterValue : itm.id }).length>0){
                itm.active = true;
            }
            return itm;
        });
        
    },

    initialize: function(options) {
        this.firstLoad = true;
        this.filterType = options.filterType;
        this.filterData = options.filterData;
        this.initialActiveFilters = options.initialActiveFilters;
        this.setActiveFilters();
        this.manageFillList();
    }
});
